import React from 'react';
import { DevLogo } from './DevLogo';
import styles from 'components/shared/NavigationBar/NavigationBar.module.scss';
import { NavLink } from 'react-router-dom';

export const DevNavigationBar = () => {
  return (
    <header className={styles.container}>
      <div className={styles.outerBin}>
        <div className={styles.bin}>
          <NavLink to={`/`}>
            <DevLogo />
          </NavLink>
        </div>
      </div>
    </header>
  );
};
